import React from 'react';
import EmptySearch from "../assets/images/illustrations/empty_search.png";
var AssignmentTemplatesEmpty = function AssignmentTemplatesEmpty() {
  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: EmptySearch,
    alt: "Empty",
    className: "img-fluid",
    width: 500
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("h3", null, "No result"), /*#__PURE__*/React.createElement("p", {
    className: "text-muted"
  }, "No assignment template matches your search.")))));
};
export default AssignmentTemplatesEmpty;